export default {
  list: state => state.staffList,
  detail: state => id => {
    if(id == 'unassigned' || id == undefined) {
        return null;
    } else {
        return state.staffList.filter(staff => staff.user_id == id);
    }
  },
  staffListWithSearch: state => name => {
    if(name != '') {
        let search_arr = [];
        for(let i = 0; i < state.staffList.length; i++) {
            if(state.staffList[i].name.toLowerCase().includes(name.toLowerCase())) {
                search_arr.push(state.staffList[i]);
            }
        }
        // console.log(search_arr)
        return search_arr;
    } else {
        return state.staffList;
    }
  }
}
